import React from 'react'
import { Field, FieldProps, FormikProps } from 'formik'
import { Dropdown } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { ModifyContractInput } from '../../../../../common/validations'
import FormFieldWrapper from '../../../../components/FormField'

type TransferDestinationOption = {
  id: number
  label: string
}

export type TransferDestinationFieldProps = {
  form: FormikProps<ModifyContractInput>
  options: TransferDestinationOption[]
  sourceTenantId: number
}

export const TransferDestinationField: React.FC<
  TransferDestinationFieldProps
> = ({ form, options, sourceTenantId }) => {
  const { t } = useTranslation(['contractModification'])

  return (
    <Field name="transfer.destinationTenantId">
      {({
        field,
        meta,
      }: FieldProps<
        NonNullable<ModifyContractInput['transfer']>['destinationTenantId']
      >) => (
        <FormFieldWrapper
          name={field.name}
          label={t('contractModification:labels.transferDestination')}
          className="min-tablet:max-w-96 mt-8"
          meta={meta}
          labelBold
          required
        >
          <Dropdown
            options={options}
            onChange={async (option) => {
              if (option) {
                await form.setFieldValue(field.name, option.id, false)
                await form.setFieldValue(
                  'transfer.sourceTenantId',
                  sourceTenantId
                )
              } else {
                await form.setFieldValue('transfer', undefined)
              }
              await form.setFieldTouched('transfer.destinationTenantId', true)
            }}
            value={options.find((option) => option.id === meta.value)}
            allowEmpty
          />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
